import { World } from "miniplex";
import type { Entity } from "./components";

export type EcsWorld = World<Entity>;

export const createEcsWorld = (): EcsWorld => new World<Entity>();
